import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {fetchList, printOrderDelivery, getOrderSku, syncOrder, listShop} from '@/api/oms/shopee-order';
import moment from 'moment';
import { Message } from 'element-ui';
import {getAllDepotList} from "@/api/sms/arrival-order";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		multipleSelection: [],
		goodsList: [],
		drawerVisible: false,
		depotList: [],
		orderDictList: [],
		operatorList: []
	},
	actions: {
		async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'oms.shopee-order.list', async function () {
				const { searchForm } = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						orderSn: searchForm.orderSn,
						shopeeOrderSn: searchForm.platformOrderSn,
						shopId:searchForm.shopId,
						status: searchForm.status,
						...payload
					}
				});
			})
		},

		async syncOrder({ state, dispatch }, payload) {
			await wait(dispatch, `oms.shopee-order.sync.${payload}`, async function () {
				const { code, message } = await syncOrder(payload)
				if(code !== 200){
					Message.error(message)
				}else{
					dispatch('getList')
				}
			})
		},

		async getOrderSku({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'sms.forwarding-order.sku', async function () {
				const response = await getOrderSku(payload);
				if (response.data && response.data.length > 0) {
					commit('save', {
						goodsList: response.data
					})
				} else {
					Message.error({
						message: '无此订单',
						onClose: () => {
							commit('closeDrawer')
						}
					})
				}
			})
		},

		async getShopIdList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'sms.shopee-order.all-shop-id', async function() {
				const response = await listShop();
				console.log(state);
				if (response.data) {
					commit('save', {
						shopIdList: response.data
					});
				}
			})
		},

	},
	mutations: {
		openDrawer(state) {
			Object.assign(state, { drawerVisible: true })
		},
		closeDrawer(state) {
			Object.assign(state, { drawerVisible: false })
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/shopee-order/list.js